module.exports = __webpack_public_path__ + "static/HowToPlay-a20710633216c04ffb77c8b5c3d774da.png";